import { useEffect, useRef, useState } from 'react'
import { resolveComponentVariant } from '../componentContract'
import styles from './Feedback.module.css'

export function Skeleton({ show = true, delay = 150, minimumDuration = 300, shape = 'block', width = '100%', height = '1rem', label = 'Loading content', announce = true, className = '' }) {
  const [visible, setVisible] = useState(false)
  const shownAt = useRef(0)
  const resolvedShape = resolveComponentVariant('Skeleton shape', shape, ['block', 'text', 'circle'], 'block')

  useEffect(() => {
    let timer
    if (show && !visible) {
      timer = window.setTimeout(() => { shownAt.current = Date.now(); setVisible(true) }, Math.max(0, delay))
    } else if (!show && visible) {
      const remaining = Math.max(0, minimumDuration - (Date.now() - shownAt.current))
      timer = window.setTimeout(() => setVisible(false), remaining)
    }
    return () => window.clearTimeout(timer)
  }, [delay, minimumDuration, show, visible])

  if (!visible) return null
  return <span role={announce ? 'status' : undefined} aria-label={announce ? label : undefined} aria-hidden={announce ? undefined : 'true'} className={`${styles.skeleton} ${resolvedShape === 'text' ? styles.skeletonText : ''} ${resolvedShape === 'circle' ? styles.skeletonCircle : ''} ${className}`.trim()} style={{ width, height }} />
}
